import { NativeSelect, TextInput } from "./FormControls";
import IconButton from "./IconButton";
import SystemIcon from "./SystemIcon";

export function SearchInput({
  buttonLabel = "검색",
  loading = false,
  onSearch,
  wrapperClassName = "",
  style,
  ...inputProps
}) {
  return (
    <span
      className={`ds-search-input${wrapperClassName ? ` ${wrapperClassName}` : ""}`}
      style={style}
    >
      <TextInput type="search" {...inputProps} />
      <IconButton
        label={buttonLabel}
        type={onSearch ? "button" : "submit"}
        size="medium"
        className="ds-search-input__submit"
        disabled={loading}
        aria-busy={loading || undefined}
        onClick={onSearch}
      >
        {loading
          ? <span className="ds-button__spinner" aria-hidden="true" />
          : <SystemIcon name="search" size="xsmall" />}
      </IconButton>
    </span>
  );
}

export default function SearchBar({
  field,
  setField,
  text,
  setText,
  fields,
  loading,
  onSearch,
  placeholder = "검색어",
  inputWidth = 320,
}) {
  const activePlaceholder = fields.find((option) => option.value === field)?.placeholder || placeholder;
  const width = Math.min(
    480,
    Math.max(inputWidth, Array.from(String(activePlaceholder || "")).length * 15 + 56)
  );

  return (
    <div className="ds-searchbar">
      <NativeSelect
        wrapperClassName="ds-searchbar__select"
        aria-label="검색 기준"
        value={field}
        onChange={(event) => setField(event.target.value)}
      >
        {fields.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </NativeSelect>

      <SearchInput
        aria-label="검색어"
        value={text}
        onChange={(event) => setText(event.target.value)}
        placeholder={activePlaceholder}
        style={{ width }}
        loading={loading}
        onSearch={onSearch}
        onKeyDown={(event) => {
          if (event.key === "Enter") onSearch();
        }}
      />
    </div>
  );
}
